// extracted by mini-css-extract-plugin
module.exports = {"buttons":"PolicyChange_buttons__2pv0g","container":"PolicyChange_container__lZT87"};